import { ReactNode, useState } from "react"

import { LayoutContext } from "@/App/layoutContextDef"

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [headerExtra, setHeaderExtra] = useState<ReactNode>(null)

  return (
    <LayoutContext.Provider value={{ headerExtra, setHeaderExtra }}>
      {children}
    </LayoutContext.Provider>
  )
}
